import { Message } from "primereact/message";
import React, { useMemo } from "react";
import {
  CvpCard,
  CvpCardPadding,
} from "../../generic-components/cards/CvpCard";
import { useLocStore } from "../../localization";
import { LocContext } from "../../localization/LocContext";
import {
  getApplyRedirectProps,
  getJobRedirectProps,
} from "../../url/getJobRedirectProps";
import { optimizeImageUrl } from "../../url/synchronizeCacheBusterParameter";
import { parseJobHtml } from "../../utils/parseJobHtml";
import { ApplyWithProfileForm } from "../forms/applyWithProfile/ApplyWithProfileForm";
import { useApplyWithProfileFormData } from "../forms/applyWithProfile/useApplyWithProfileFormData";
import { PageLayout } from "../layout/PageLayout";
import { CvpCardBreadCrumb } from "../nav/embed/CvpCardBreadCrumb";
import { CustomMenuItem } from "../nav/MenuItems/completeMenuItem";
import {
  StyledAppliedMessage,
  StyledHeading,
  StyledSubHeading,
} from "./ApplySharedStyles";

export default () => {
  const {
    idRelatedResolved,
    isCandidateAttachedToCase,
    isFetched,
    job,
    typeRelatedResolved,
  } = useApplyWithProfileFormData();

  const L = useLocStore(LocContext.GENERAL);

  const heading = useMemo(() => {
    return parseJobHtml(job?.jobText?.heading ?? "");
  }, [job?.jobText?.heading]);

  if (!isFetched) return null;

  const logoUrl = optimizeImageUrl(job.job.urlLogo);

  if (isCandidateAttachedToCase) {
    return (
      <PageLayout extraPadding>
        <StyledAppliedMessage>
          <Message
            severity="info"
            text={L.id("36bd0844602b").loc(
              "Du har allerede søkt på denne stillingen"
            )}
          />
        </StyledAppliedMessage>
      </PageLayout>
    );
  }

  const breadcrumbItems: CustomMenuItem[] = [
    {
      label: L.id("5df758efecf6").loc("Ledige stillinger"),
      isSelected: () => false,
      path: "jobs",
    },
    {
      label:
        job.jobText.jobtitle ||
        job.job.positionTypeFreeText ||
        job.job.positionType,
      isSelected: () => false,
      ...getJobRedirectProps(idRelatedResolved, typeRelatedResolved),
    },
    {
      label: L.id("33bb536e3738").loc("Søk på stilling"),
      isSelected: () => true,
      ...getApplyRedirectProps(idRelatedResolved, typeRelatedResolved),
    },
  ];

  return (
    <PageLayout extraPadding>
      <CvpCard border noPaddingTop>
        <CvpCardBreadCrumb
          breadcrumbItems={breadcrumbItems}
          className="cvp-card-breadcrumb"
          embedProps={{ showBreadCrumb: true }}
        />
        <CvpCardPadding>
          <StyledHeading>
            <h1 className="cvp-h1">
              {L.id("b2dc0e49e969").loc("Søk på stilling")}
            </h1>
            {!!logoUrl && <img src={logoUrl} key={logoUrl} />}
          </StyledHeading>

          <StyledSubHeading>
            <h2 className="cvp-h2">{heading}</h2>

            <p>
              {L.id("876a9a102014").loc(
                "Så hyggelig at du ønsker å søke hos oss. For å søke må du skrive " +
                  "en kort søknadstekst, hake av for samtykke og trykke Send søknad."
              )}
            </p>
          </StyledSubHeading>

          <ApplyWithProfileForm />
        </CvpCardPadding>
      </CvpCard>
    </PageLayout>
  );
};
